import { render, staticRenderFns } from "./MapaEntregasClientes.vue?vue&type=template&id=31ab8e0c&"
import script from "./MapaEntregasClientes.vue?vue&type=script&lang=js&"
export * from "./MapaEntregasClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports